import React from "react";
import { Props } from "./types";

function FrenchIcon({ className }: Props) {
  return (
    <svg className={className} viewBox="0 0 27 27">
      <defs>
        <clipPath id="clip-path-french-flag">
          <circle
            id="Ellipse_532"
            data-name="Ellipse 532"
            cx="13.5"
            cy="13.5"
            r="13.5"
            transform="translate(755 305)"
            fill="#fff"
            stroke="#707070"
            strokeWidth="1"
          />
        </clipPath>
      </defs>
      <g
        id="Groupe_de_masques_8"
        data-name="Groupe de masques 8"
        transform="translate(-755 -305)"
        clipPath="url(#clip-path-french-flag)"
      >
        <g id="france" transform="translate(755 305)">
          <path
            id="Tracé_3266"
            data-name="Tracé 3266"
            d="M18,.771,16.425,5.14a32.59,32.59,0,0,1,0,16.721L18,26.228A13.5,13.5,0,0,0,18,.771Z"
            fill="#e61e25"
          />
          <g id="Groupe_2700" data-name="Groupe 2700">
            <path
              id="Tracé_3267"
              data-name="Tracé 3267"
              d="M18,5.14V.771A13.473,13.473,0,0,0,13.5,0C15.582,0,12.7,7.055,18,5.14Z"
              fill="#e4e4e4"
            />
            <path
              id="Tracé_3268"
              data-name="Tracé 3268"
              d="M13.5,27a13.471,13.471,0,0,0,4.5-.771V21.861C12.749,21.337,13.5,27,13.5,27Z"
              fill="#e4e4e4"
            />
          </g>
          <path
            id="Tracé_3269"
            data-name="Tracé 3269"
            d="M0,13.5A13.5,13.5,0,0,0,9.052,26.246V.754A13.5,13.5,0,0,0,0,13.5Z"
            fill="#3757a6"
          />
          <path
            id="Tracé_3270"
            data-name="Tracé 3270"
            d="M18,5.14V21.861A32.587,32.587,0,0,0,18,5.14Z"
            fill="#ef4f4e"
          />
          <path
            id="Tracé_3271"
            data-name="Tracé 3271"
            d="M18,21.861V5.14C17.082,2.105,15.582,0,13.5,0A13.471,13.471,0,0,0,9.052.754V26.246A13.471,13.471,0,0,0,13.5,27C15.582,27,17.082,24.895,18,21.861Z"
            fill="#f3f4f5"
          />
        </g>
      </g>
    </svg>
  );
}

export { FrenchIcon };
